import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Menu from 'Menu';
import Footer from './Footer';
import LoadingBar, { showLoading, hideLoading } from 'react-redux-loading-bar';
import { NotificationContainer } from 'react-notifications';
import { HORIZONTAL } from 'constants';
import SubMenu from './menu/SubMenu';
import { browserHistory } from "react-router";
import { SelectCommunity } from "./SelectCommunity/SelectCommunity";

const Layout = ({
  auth,
  fetched,
  currentNavPage,
  subMenuDirection,
  redirectUrl,
  orderLines,
  location,
  dispatch,
  children,
  step
}) => {

  const prevRedirectUrl = useRef(redirectUrl);
  const prevFetched = useRef(fetched);

  // componentWillUpdate + componentDidUpdate (location)
  useEffect(() => {
    if (location.action === 'PUSH') {
      dispatch(showLoading());
      dispatch(hideLoading());
    }
  }, [location]);

  // componentDidUpdate (redirectUrl / fetched)
  useEffect(() => {
    if (prevRedirectUrl.current !== redirectUrl || prevFetched.current !== fetched) {
      if (fetched && redirectUrl != null) {
        browserHistory.push(redirectUrl);
      }
    }
    prevRedirectUrl.current = redirectUrl;
    prevFetched.current = fetched;
  }, [redirectUrl, fetched]);

  const { fetching, currentClient, user } = auth;

  //pour fixer probléme de la page de paiement
  // if(user && !currentClient) {
  //   return <SelectCommunity />;
  // }

  const showMenu = currentNavPage !== "STATISTICS-IFRAME"
    && orderLines.embedded == 0
    && currentNavPage !== "NOT_FOUND_PAGE"
    && currentNavPage !== "PAYMENT_REFUSED"
    && currentNavPage !== "REFUND_PAGE";

  return (
    <div style={{ minHeight: "100vh" }} id="offCanvas-wrapper" className="off-canvas-wrapper">
      <div>
        <LoadingBar className="loading-bar" />
        {showMenu ? <Menu /> : null}
        <NotificationContainer />
        <div>
          {showMenu ? <SubMenu /> : null}
          <div>
            {children}
            {(["HOME"].indexOf(currentNavPage) !== -1) ? <Footer /> : null}
          </div>
        </div>
      </div>
      <div className="mask hide"></div>
    </div>
  );
};

const mapStateToProps = (store) => ({
  auth: store.auth,
  fetched: store.auth.fetched,
  currentNavPage: store.params.currentNavPage,
  subMenuDirection: store.params.subMenuDirection,
  redirectUrl: store.auth.redirectUrl,
  orderLines: store.orderLines,
});

export default connect(mapStateToProps)(Layout);


// WEBPACK FOOTER //
// ./app/components/Layout.js